import { ofType } from 'redux-observable';
import { filter, mergeMap, of, map } from 'rxjs';
import { ConfDefnComponentType, StyleCollectionComponent } from 'configuration-schemas/confdefnComponents';
import { AppEpic } from 'src/store';
import {
  inputIsNotNullOrUndefined,
  isScopeDefined,
  maybeGetComponentProps,
  topMemInWorklistSelected,
} from 'src/utils/Functions/epicsFunctions';
import { receiveScopeRefreshTrigger } from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { setActivePage, setActiveSubPage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { receiveWorklistConfig, updateSelectedItem } from 'src/pages/Worklist/Worklist.slice';
import {
  fetchStyleCollection,
  fetchStyleCollectionConfigs,
  fetchStyleCollectionItems,
  receiveStyleCollectionConfig,
  requestStyleCollectionConfig,
} from './StyleCollection.slice';
import { isNil } from 'lodash';
import { ViewDefnState } from 'src/dao/tenantConfigClient';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { ListDataOptions } from 'src/worker/pivotWorker.types';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from '../Planning.types';

export const styleCollectionConfigLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(setActivePage.type, setActiveSubPage.type, receiveWorklistConfig.type, requestStyleCollectionConfig.type),
    map(() => maybeGetComponentProps<StyleCollectionComponent>(state$.value, ConfDefnComponentType.styleCollection)),
    filter(inputIsNotNullOrUndefined),
    filter(() => {
      // config fetch can be triggered by worklist or by standalone component request
      // only fetch if we haven't fetched already regardless of who triggered it
      const slice = state$.value.pages.assortmentBuild.styleCollection;
      return isNil(slice.viewDefn) && slice.viewDefnState === ViewDefnState.idle;
    }),
    mergeMap(({ defns }) => {
      return of(fetchStyleCollectionConfigs(defns));
    }),
  );
};

export const styleCollectionDataLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      receiveStyleCollectionConfig.type,
      updateSelectedItem.type,
      LENS_ASST_PLAN_REFRESHING_PAGE,
    ),
    map(() => maybeGetComponentProps<StyleCollectionComponent>(state$.value, ConfDefnComponentType.styleCollection)),
    filter(inputIsNotNullOrUndefined),
    filter(() => isScopeDefined(state$.value.scope)),
    filter(() => topMemInWorklistSelected(state$.value)),
    mergeMap(({ collectionDataApi, itemsDataApi }) => {
      const collectionOptions: ListDataOptions = {
        aggBy: collectionDataApi.params.aggBy,
        topMembers: state$.value.worklist.selectedItemId,
      };
      const itemsOptions: ListDataOptions = {
        aggBy: itemsDataApi.params.aggBy,
        topMembers: state$.value.worklist.selectedItemId,
      };

      return of(
        fetchStyleCollection(collectionDataApi.defnId, collectionOptions),
        fetchStyleCollectionItems(itemsDataApi.defnId, itemsOptions),
      );
    }),
  );
};
